<template>
	<FontAwesomeIcon
		:icon="faBookmark"
		class="ribbon ribbon--left"
		@click.prevent.stop="preventNonSignedInAction(undefined, additionalContexts)"
	/>
</template>

<script setup lang="ts">
import { SnowplowContext } from '@/helpers/tracking/providers';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import { preventNonSignedInAction } from '@/helpers/prevent-non-signed-in-action-helper';

withDefaults(
	defineProps<{
		position?: 'left' | 'right';
		additionalContexts?: SnowplowContext[];
	}>(),
	{
		position: 'left',
		additionalContexts: () => [],
	}
);
</script>

<style scoped lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/rtl-support-mixins';

.ribbon {
	position: absolute;
	z-index: 2;
	font-size: 32px;
	padding: 0 8px 8px;
	top: -2px;
	color: $jw-color-white;
	opacity: 0.3;

	&--left {
		@include inset-inline('start', 0);
	}

	&:hover {
		opacity: 0.7;
		cursor: pointer;
	}
}
</style>
